/* lvx-trial-guard.js — one free trial per order.
   Any cart line whose SKU starts with LV-RECP-TRIAL is pinned to quantity 1 and any
   duplicate trial lines are removed, wherever the cart is edited (PDP, drawer, /cart).
   Other products alongside it are untouched. Site-wide, loaded from theme.liquid. */
(function () {
  var SKU = 'LV-RECP-TRIAL';
  var busy = false;
  function check() {
    if (busy) return; busy = true;
    fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
      var trials = (cart.items || []).filter(function (i) { return (i.sku || '').indexOf(SKU) === 0; });
      if (!trials.length) { busy = false; return; }
      var updates = {}, changed = false;
      trials.forEach(function (it, idx) {
        var want = idx === 0 ? 1 : 0;
        if (it.quantity !== want) { updates[it.key] = want; changed = true; }
      });
      if (!changed) { busy = false; return; }
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) })
        .then(function () {
          busy = false;
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          if (location.pathname.indexOf('/cart') === 0) location.reload();
        }).catch(function () { busy = false; });
    }).catch(function () { busy = false; });
  }
  window.lvxTrialCheck = check;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check); else check();
  document.addEventListener('cart:refresh', function () { setTimeout(check, 400); });
  /* re-check after any cart mutation made through fetch (theme drawer, our ATC, apps) */
  var of = window.fetch;
  window.fetch = function (u) {
    var p = of.apply(this, arguments);
    try {
      var url = (typeof u === 'string') ? u : ((u && u.url) || '');
      if (/\/cart\/(add|change|update)/.test(url)) p.then(function () { setTimeout(check, 300); });
    } catch (e) {}
    return p;
  };
})();
